import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'
const VtInformationForm = ({ navigation, route }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params

  const { loading, postvtonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()

  const options1 = [
    { key: 1, value: 'Single' },
    { key: 2, value: 'Married/Civil Union Filing Jointly' },
    { key: 3, value: 'Married/Civil Union Filing Separately' },
    { key: 4, value: 'Married, but withhold at higher single rate' }
  ]

  const intialValues = {
    maritalstatus: '',
    nooneclaim: '',
    filingjointly: '',
    noofdependents: '',
    headofhousehold: '',
    additionalamount: '',
    exempt: ''
  }
  const paschema = yup.object({
    maritalstatus: yup.string().required('Filing status is a required field'),
    nooneclaim: yup.string().matches(/^1$/, "Enter '1' or leave it empty").nullable(),
    filingjointly: yup.string().matches(/^1$/, "Enter '1' or leave it empty").nullable(),
    noofdependents: yup.string().nullable(),
    headofhousehold: yup.string().matches(/^1$/, "Enter '1' or leave it empty").nullable(),
    additionalamount: yup.string().nullable(),
    exempt: yup.string().matches(/^exempt$/i, "Enter 'Exempt' or leave it empty").nullable(),
  })
  let totalnoofvtallowances
  const calculate = (values) => {
    totalnoofvtallowances = Number(values?.nooneclaim) + Number(values?.filingjointly) + Number(values?.noofdependents) + Number(values?.headofhousehold)
  }
  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'VT Witholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={paschema}
          onSubmit={async (values, actions) => {
            calculate(values)
            const data = {
              entityId: personalstore?.personalData?.entityId,
              essUserKey: initializestore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              maritalStatus: values?.maritalstatus,
              noOneClaim: values?.nooneclaim ? values?.nooneclaim : null,
              filingJointly: values?.filingjointly ? values?.filingjointly : null,
              noOfDependents: values?.noofdependents ? values?.noofdependents : null,
              headOfHousehold: values?.headofhousehold ? values?.headofhousehold : null,
              totalNoOfVtallowances: totalnoofvtallowances,
              additionalAmount: values?.additionalamount ? values?.additionalamount : null,
              exempt: values?.exempt,
            }

            const response = await postvtonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('VtInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  totalnoofvtallowances
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '65%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.maritalstatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('maritalstatus', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.maritalstatus &&
                      props.errors.maritalstatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.maritalstatus}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter “1” for yourself if no one can claim you as a dependent.'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.nooneclaim}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('nooneclaim')(text)
                        }
                      }}
                    />
                    {props.touched.nooneclaim && props.errors.nooneclaim && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.nooneclaim as string}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter “1” if you are filing jointly and your spouse does not work'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.filingjointly}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('filingjointly')(text)
                        }
                      }}
                    />
                    {props.touched.filingjointly && props.errors.filingjointly && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.filingjointly as string}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter the number of dependents you plan to claim on your tax return. If you file jointly, then only one of you should claim the dependents on your W-4VT'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.noofdependents}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('noofdependents')(text)
                        }
                      }}
                    />
                    {props.touched.noofdependents && props.errors.noofdependents && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.noofdependents as string}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter “1” if you plan to file as “head of household”'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.headofhousehold}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('headofhousehold')(text)
                        }
                      }}
                    />
                    {props.touched.headofhousehold && props.errors.headofhousehold && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.headofhousehold as string}
                      </Text>
                    )}
                  </View>
                </View>
                {props.values.exempt?.toLowerCase() !== 'exempt' && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '70%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Enter an additional amount, if any, you want withheld from each check'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalamount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalamount')(text)
                          }
                        }}
                      />
                      {props.touched.additionalamount && props.errors.additionalamount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalamount as string}
                        </Text>
                      )}
                    </View>
                  </View>
                )}
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'If you had a right to a refund of all your Vermont income tax withheld last year because you had no tax liability and you also expect to have no liability this year, write “Exempt” here.'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.exempt}
                      onChangeText={(text) => {
                        props.handleChange('exempt')(text)
                        if (text?.toLowerCase() === 'exempt') {
                          props.setFieldValue('additionalamount', '')
                        }
                      }}
                    />
                    {props.touched.exempt && props.errors.exempt && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.exempt as string}
                      </Text>
                    )}
                  </View>
                </View>
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default VtInformationForm
